import gql from 'graphql-tag'

export const correctiveActionDelete = gql`
  mutation correctiveActionDelete($correctiveActionId: ID!) {
    correctiveActionDelete(input: { correctiveActionId: $correctiveActionId }) {
      success
    }
  }
`
